<template>
    <div class="matching-topic" :class="{'sub-page': topicIndex != undefined}">
        <el-row style="margin-top: 10px; margin-bottom: 22px;">
            <el-col :span="14">
                    <div class="image-show-wrap">
                        <div class="img-wrap">
                            <canvas id="imgcanvas"></canvas>
                        </div>
                    </div>
                </el-col>
                <el-col :span="10">
                        <!-- <el-button @click="showimage">显示图片</el-button> -->
                        <div class="opr-wrap">

                            <el-upload
                                class="upload-demo"
                                :action="imgUpload.api"
                                :data="imgUpload.params"
                                accept=".jpg,.jpeg,.bmp,.png"
                                name="upfile"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess">
                                <el-button size="small" type="primary">{{$t('topic.clickUpload')}}</el-button>
                                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                            </el-upload>

                        </div>

                        <el-form
                            :model="topicForm"
                            :rules="rules"
                            ref="topicForm"
                            :label-width="$i18n.locale === 'zh-CN' ? '120px': '180px'"
                            class="match-form">
                            <el-form-item :label="$t('topic.questionDesc')" prop="title" style="margin-right:50px">
                                <el-input v-model="topicForm.title" :placeholder="$t('tip.titleDesc')" clearable></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('c.operatorLevel')" prop="forLevel">
                                <el-select v-model="topicForm.forLevel" :placeholder="$t('tip.operatorLevel')">
                                    <el-option :label="item.value" :value="item.id" v-for="item in forLevelMenu"
                                            :key="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('c.difficulty')" prop="difficulty">
                                <el-select v-model="topicForm.difficulty" :placeholder="$t('tip.difficulty')">
                                    <el-option :label="item.value" :value="item.id" v-for="item in difficultyDict"
                                            :key="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('c.knowledgePoint')" prop="knowledge">

                                <el-cascader
                                    v-model="topicForm.knowledge"
                                    :options="knowledgeMenu['Theory']"
                                    :props="cascadeProp"
                                    :show-all-levels="false"
                                ></el-cascader>

                            </el-form-item>
                            <el-form-item label=" " class="analysis" label-width="50px">
                                <el-collapse v-model="activeNames" accordion>
                                    <el-collapse-item :title="$t('topic.addOrEditAnalyse')" name="1">
                                        <quill-editor v-model="analysisRT" ref="analysisRT"></quill-editor>
                                    </el-collapse-item>
                                </el-collapse>
                            </el-form-item>
                        </el-form>

            </el-col>
        </el-row>

        <div class="btn-group">
            <el-button @click="$router.back()" size="medium">取消</el-button>
            <el-button type="primary" size="medium" :loading="topicLoading" @click="saveSubmit">{{$t('c.save')}}</el-button>
        </div>

        <Drawer title="选择标注类型" :visible=markShow
            :styleWidth="400">
            <div class="drawer-content">
                <el-collapse v-model="collapseValue"  accordion>
                    <el-collapse-item v-for="(item,pidx) in knowledgeData" :name="item.value" :key="item.value">
                        <template slot="title">
                            {{item.value}}
                        </template>
                        <div>
                            <ul>
                                <li v-for="(item2,sidx) in item.children" :key="item2.value" class="content-item" :class="{'selected':item2.selected}" @click="markSelectChange(item2,pidx,sidx)">
                                <span class="item-name">{{item2.value}}</span></li>
                            </ul>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
            <div class="demo-drawer-footer">
                <el-button style="margin-right: 8px" @click="cancelSelect">取消</el-button>
                <el-button type="primary" :disabled="!markValue" @click="markSelectSave">确认</el-button>
            </div>
        </Drawer>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'
import QuillEditor from "@/components/QuillEditor"
const config = require('@/config');
import api from '@/api'
import { Ticket, Cascade } from '@/utils'
import { DrBluePrint } from '@/utils/drBluePrint'
import SparkMD5 from 'spark-md5'
import axios from 'axios'
import Drawer from '@/pages/MapManage/Drawer'
const MAX_SIZE = 10

const imgURL = `${config.baseUrl}/fileapi/WebUploader/UEditor`;


export default {
    /**
     * 三种状态：
     * 无topicID，添加试题；
     * 有topicID，无topicIndex，编辑试题
     * 有topicID，有topicIndex，考卷中的编辑试题
     **/
    props: {
        topicID: {
            type: String,
            required: true
	},
	topicIndex: {}
    },
    components: {
        Drawer,
        QuillEditor
    },
    data() {
        return {
            topicForm: {
                title: '请为图中选项匹配对应的物品类型',
                forLevel: '',
                difficulty: '',
                knowledge: [],
                description: ''
            },
            analysisRT: '',
            rules: {
                forLevel: [
                    {required: true, message: this.$t('tip.operatorLevel'), trigger: 'change'}
                ],
                difficulty: [
                    {required: true, message: this.$t('tip.difficulty'), trigger: 'change'}
                ],
                knowledge: [
                    {required: true, message: this.$t('tip.knowledgePoint'), trigger: 'change'}
                ],
                title: [
                    {required: true, message: this.$t('tip.titleDesc'), trigger: 'change'}
                ],
            },
            difficultyDict: [],
            dialog: {
                type: 4,
                isMultiSelect: false,
                isImageDialogOpen: false,
                canSelectTip: false,
                activeTab: '0',
                viewCount: 1,
                initData: {}
            },
            saveBtnDisable: true,
            // 初始化右侧图像信息
            showImgInfo: {
                byName: '',
                knowledgeName: '',
                description: ''
            },
            cascadeProp: {
                value: 'id',
                label: 'value',
                children: 'children'
            },
            options: {
                target: api.simpleUploadURL,
                chunkSize: '2048000',
                fileParameterName: 'upfile',
                testChunks: true,     //是否开启秒传
                maxChunkRetries: 3,
                //generateUniqueIdentifier:function(){return "987654321"},
                checkChunkUploadedByResponse: function (chunk, message) {
                    var objMessage = JSON.parse(message);
                    if (objMessage.skipUpload) {
                        return true;
                    }
                    return (objMessage.uploaded || []).indexOf(chunk.offset + 1) >= 0
                },
                headers: {
                },
            },

            imageAttr: {accept: ['.png', '.jpg', '.jpeg', '.bmp']},
            imageFile: {
                reName:'',
                resourceID: 0,
                resURL: '',
                upFileID: 0,
                upProgress: 0,
                fileType: 0,
                extension: '',
            },
            markShow: false,
            collapseValue: [],
            knowledgeData: [],
            imgUpload: {
                api: imgURL,
                params: {
                    'access_token': Ticket.get().access_token
                },
            },
            imageUrl:'',
            viewUrl:'',
            markValue: '',
            markId: '',
            topicLoading: false,
            editData: undefined,
            markedTangleLength:0
        }
    },
    created() {
        this.$store.dispatch('getForLevelMenu')
        this.$store.dispatch('getKnowledgeMenu', {
            type: 'Theory'
        })
        api.getDifficulty().then(res => {
            this.difficultyDict = res.package;
        })
        api.getAnswerType().then(res => {
            this.knowledgeData = res.package;
        })

    },
    mounted () {
        if (this.topicID) {
            this.initGetTopicInfo()
        }
    },
    computed: {
        ...mapGetters([
            'forLevelMenu',
            'knowledgeMenu',
        ]),
	//Uploader实例
        uploader() {
            return this.$refs.uploader.uploader;
        },
    },
    methods: {
        // 图片上传
        handleAvatarSuccess(res, file) {
            if (res.result) {
                this.imageUrl = res.url
                let imageData= {
                    url: res.url,
                    rectangleOptions: []
                }
                if(!this.drBluePrint){
                    this.drBluePrint = new DrBluePrint()
                }
                this.drBluePrint.setMiddleMouseSelectCallback(this.middleMouseSelectCallback)
                this.drBluePrint.show(imageData)
                this.markedTangleLength = 0
            } else {
                this.$message.error(res.message)
            }
        },
        uploadImage(){
            $('#uploadImage').click()
        },
        middleMouseSelectCallback (pos, len) {

            if(len >=5 ){
                this.$message.error('配对题选项至少两个，最多四个')
                this.drBluePrint.removeUserMarkedRectangleText(len - 1)
                return
            }
            this.markedTangleLength = len
            this.markShow = !this.markShow

            this.markValue = ''
            this.markId = ''
            this.knowledgeData.forEach(item => {
                if (item.children) {
                    item.children.forEach(item2 => {
                        item2.selected = false
                    })
                }
            })
        },

        markSelectChange (data, pidx, sidx) {
            this.knowledgeData.forEach(item => {
                if (item.children) {
                    item.children.forEach(item2 => {
                        item2.selected = false
                    })
                }
            })
            this.knowledgeData[pidx].children[sidx].selected = true
            this.$set(this.knowledgeData[pidx].children, sidx, this.knowledgeData[pidx].children[sidx])
            this.markValue = data.value
            this.markId = data.id
        },
        // 取消 关闭抽屉
        cancelSelect () {
            this.markShow = false
            this.drBluePrint.removeUserMarkedRectangleText(this.markedTangleLength - 1)
        },
        markSelectSave () {
            let color = '#f00'
            this.drBluePrint.addUserMarkedRectangleText(this.markedTangleLength - 1, this.markValue,this.markId, color)
            this.markShow = !this.markShow
        },
        onCloseDrawer () {
            this.markShow = false
        },


        // 考题保存
        saveSubmit() {
            if(!this.imageUrl){
                this.$message.error('请上传图片')
                return
            }
            let options = this.drBluePrint.getUserMarkedRectanglesInfo()
            if(options.length <= 1){
                this.$message.error('配对题选项至少两个，最多四个！')
                return
            }
            this.$refs['topicForm'].validate((valid) => {
                if (!valid) {
                    return;
                }
                let postData = {
                    difficulty: this.topicForm.difficulty,
                    forLevel: this.topicForm.forLevel,
                    knowledge: this.topicForm.knowledge[this.topicForm.knowledge.length - 1],
                    type: 4, //
                    title: this.topicForm.title,
                    titleRT: this.topicForm.title,
                    analysis: this.$refs.analysisRT.quill.getText(),
                    analysisRT: this.analysisRT,
                    picSrcUrl: this.imageUrl,
                    rectangleOptions: options
                }
                // 不可点击，防止重复点击提交
                this.topicLoading = true
                //获取合成图片并上传
                let dataurl = this.drBluePrint.getMarkedImage()

                var form = new FormData()

                form.append("upfile", this.dataURLtoBlob(dataurl), "image.png")

                axios.post(imgURL, form, {params: {'access_token': Ticket.get().access_token}}).then(res=>{

                    postData.picViewUrl = res.url
                    if (this.topicID) {
                        api.editPairTopic(this.topicID, postData).then(res => {
                            this.topicLoading = false;
                            this.$message({
                                message: this.$t('m.editSuccess'),
                                type: 'success'
                            })
                            this.$router.back();

                        }).catch(error => this.topicLoading = false);
                    } else {
                        api.addPairTopic(postData).then(res => {
                            this.topicLoading = false;
                            this.$message({
                                message: this.$t('m.addSuccess'),
                                type: 'success'
                            })

                            this.$router.back();
                        }).catch(error => this.saveBtnDisable = false);
                    }
                })

            })
        },

        dataURLtoBlob(dataurl) {
            const arr = dataurl.split(',')
            const mime = arr[0].match(/:(.*?);/)[1]
            const bstr = atob(arr[1])
            let n = bstr.length
            const u8arr = new Uint8Array(n)
            while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
            }
            return new Blob([u8arr], { type: mime })
        },
        success(type = 'operate') {
            let _msg = {
                add: this.$t('m.addSuccess'),
                edit: this.$t('m.editSuccess'),
                del: this.$t('m.delSuccess'),
                operate: this.$t('m.operateSuccess')
            };
            this.$message({
                message: _msg[type],
                type: 'success'
            })
        },

        /*
        *  考题编辑的逻辑
        */
        initGetTopicInfo() {
            api.getTheoryTopicDetail(this.topicID).then(data => {
                this.editData = data.package
                this.saveBtnDisable = false
                this.topicForm.title = this.editData.title
                this.topicForm.difficulty = this.editData.difficulty
                this.topicForm.forLevel = this.editData.forLevel
                this.topicForm.knowledge = Cascade.fullPath(this.knowledgeMenu['Theory'], this.editData.knowledge)
                this.markedTangleLength = this.editData.rectangleOptions.length
                this.analysisRT = this.editData.analysisRT

                this.topicForm.description = this.editData.analysisRT
                this.imageUrl = this.editData.picSrcUrl
                setTimeout(()=>{
                    this.showimage()
                },300)
            })
        },
        showimage(){
            let imageData= {
                url: this.editData.picSrcUrl,
                rectangleOptions: this.editData.rectangleOptions
            }
            this.drBluePrint = new DrBluePrint()
            this.drBluePrint.setMiddleMouseSelectCallback(this.middleMouseSelectCallback)
            this.drBluePrint.show(imageData)
        }

    },

}
</script>

<style lang="scss">
    @import '../../../style/const';

.matching-topic {
    .quill-editor {
        width: 80%;
        .ql-editor {
            min-height: 100px;
        }
    }
    .opr-wrap{
        margin-left: 50px;
        margin-bottom: 20px;
    }
    .image-show-wrap{
        width: 100%;
        height: 602px;
        border: 1px solid #ccc;
    }
    .img-wrap {
        display: flex;
        position: relative;
        width: 100%;
        height: 100%;
        // canvas {
        //     // width: 100%;
        //     // height: 100%;
        //     display: block;
        // }
    }
    .drawer-content{
        width: 100%;
        height: calc(100% - 51px);
        overflow-y: auto;
    }
    .demo-drawer-footer{
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        border-top: 1px solid #e8e8e8;
        padding: 10px 16px;
        text-align: right;
        background: #fff;
    }
    .content-item{
        padding: 10px 0px 10px 28px;
        cursor: pointer;
        &:hover{
            .item-name{
                color: #2d8cf0;
            }
        }
        &.selected{
            background-color: #f0faff;
            .item-name{
                color: #2d8cf0;
            }
        }
        .item-name{
            font-size: 16px;
        }
    }

    .btn-group {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 10px 0;
        text-align: center;
        background-color: #fff;
        border-top: 1px solid #eee;
        box-shadow: 0 2px 8px #ccc;

        button {
            letter-spacing: 4px;

            + button {
                margin-left: 15px;
            }
        }
    }

    .el-select-dropdown__item {
        width: 220px;
    }

    .analysis {
        > .el-form-item__content {
            width: 80%;
            @media screen and (max-width: 1280px) {
                width: 75%;
            }
        }

        .el-collapse,
        .el-collapse-item__wrap {
            border: none;
        }

        .el-collapse-item {
            border: dashed 1px #999;
            border-left: none;
            border-right: none;
        }

        .el-collapse-item__header {
            font-size: 15px;
            height: 32px;
            line-height: 32px;
            color: #999;
            text-align: center;
            border: none;
        }

        .el-collapse-item__arrow {
            float: none;
            display: inline-block;
            line-height: 32px;
        }
    }

    .el-form-item__label {
        color: $c-txt;
    }

    // 作为在考卷中的子页面
    &.sub-page {
        overflow: auto;
        /deep/ .el-form {
            margin: 20px;
            padding: 20px;
            background-color: #fff;
            border: 1px solid #ebeef5;
            border-radius: 4px;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }
    }
}

</style>
